
import { versionUtils } from '@src/corelib/utils';

function Settings({ DEBUG }) {
  // Main
  this.DEBUG = DEBUG;

  // Authentification
  this.AUTH = {
    JWT: {
      USERNAME_FIELD: 'email',
      PASSWORD_FIELD: 'password',
      ACCESS_TOKEN_FIELD: 'access',
      REFRESH_TOKEN_FIELD: 'refresh',
      // Same-origin by default: VITE_AUTH_DOMAIN is unset in production builds
      // (the SPA is served from the same origin as the API via whitenoise), so
      // URLs resolve to a relative `/api/v1/...`. In dev it's set to the API
      // host (cross-origin, allowed by CORS).
      AUTH_DOMAIN: import.meta.env.VITE_AUTH_DOMAIN || '',
      TOKEN_CREATE_URL: `${import.meta.env.VITE_AUTH_DOMAIN || ''}/api/v1/auth/jwt/token/create/`,
      TOKEN_VERIFY_URL: `${import.meta.env.VITE_AUTH_DOMAIN || ''}/api/v1/auth/jwt/token/verify/`,
      TOKEN_REFRESH_URL: `${import.meta.env.VITE_AUTH_DOMAIN || ''}/api/v1/auth/jwt/token/refresh/`,
      EXPIRED_BUFFER: 1000 * 60 * 5, // 5 minutes
    },
  };

  this.CLIENTS = {
    origin: {
      baseURL: `${import.meta.env.VITE_API_DOMAIN || ''}/api/v1`,
    },
  };


  this.init = () => {
    const version = versionUtils.getAppVersion();
    console.info(`Init | App - ${version}`);

    if (this.DEBUG) {
      console.info('Init | Settings - Development.');
    }
    else {
      console.info('Init | Settings - Production.');
    }
  };
}

function getSettings() {
  if (import.meta.env.MODE === 'production') {
    return new Settings({ DEBUG: false });
  }
  return new Settings({ DEBUG: true });
}

const settings = getSettings();

export default settings;
